import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor).

   FĂRĂ prețuri (1:1 = preț custom per client). */

/* ── 15.6 Barometrul de pe home (fără cont) ── */
export function HomeBarometer() {
  const c = useSectionContent("home_barometer");
  const [score, setScore] = useState(5);
  const [touched, setTouched] = useState(false);
  // Praguri editabile din editor: fiecare mesaj + label CTA sunt chei plate în content
  // (data-field pe <p> și pe label-ul <Link>); destinația se poate schimba din tabul Conținut.
  const msg = score <= 3
    ? { field: "low", text: c.low_text || "E greu acum. Nu ești singur — și nu trebuie să duci asta de unul singur.", cta: c.low_cta || "Vezi ce te poate ajuta acum", to: c.low_to || "/sos" }
    : score <= 6
    ? { field: "mid", text: c.mid_text || "Nici prea sus, nici prea jos. Un pas mic azi poate schimba direcția.", cta: c.mid_cta || "Fă testul de 3 minute", to: c.mid_to || "/test" }
    : { field: "high", text: c.high_text || "E o zi bună. Hai s-o hrănim — copacul tău crește din zilele astea.", cta: c.high_cta || "Intră în pădure", to: c.high_to || "/padurea" };

  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-2xl mx-auto px-5 text-center">
        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "În 10 secunde"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3 mb-6">{c.title || "Cum îți e, chiar acum?"}</h2>
        <input type="range" min="1" max="10" value={score} onChange={(e) => { setScore(Number(e.target.value)); setTouched(true); }}
          aria-label="Cum îți e acum, de la 1 la 10"
          aria-valuetext={`${score} din 10`}
          className="w-full max-w-md accent-[color:var(--ct-emerald)]" data-testid="home-barometer" />
        <div className="flex justify-between max-w-md mx-auto text-[11px] mb-6" style={{ color: "var(--ct-text-dim)" }}>
          <span>greu de tot</span><span className="font-serif text-2xl" style={{ color: "var(--ct-link)" }}>{score}</span><span>foarte bine</span>
        </div>
        {touched && (
          <div className="rise-in">
            <p data-el="subtitle" data-field={`${msg.field}_text`} className="text-base mb-5 max-w-md mx-auto" style={{ color: "var(--ct-text-muted)" }}>{msg.text}</p>
            <Link data-el="cta" to={msg.to} className="btn-gold" data-testid="home-barometer-cta"><span data-field={`${msg.field}_cta`}>{msg.cta}</span> <ArrowRight size={15} /></Link>
          </div>
        )}
        <p className="text-[11px] mt-6" style={{ color: "var(--ct-text-dim)" }}>Anonim, fără cont. Nimeni nu-ți vede răspunsul.</p>
      </div>
    </section>
  );
}
